import { Injectable } from '@angular/core';
import { ApiService } from '../../utils/api.service';
import { Observable } from 'rxjs';
import { LegalEntity } from '../../models';

@Injectable()
export class LegalEntityService {

  path = 'legal_entities';

  constructor(
    private apiService: ApiService,
  ) {
  }

  delete(legalEntity) {
    return this.apiService.delete(this.path + '/' + legalEntity.id);
  }

  getAll(): Observable<LegalEntity[]> {
    return this.apiService.get(this.path);
  }

  save(legalEntity): Observable<LegalEntity> {
    if (legalEntity.id) {
      return this.apiService.put(this.path + '/' + legalEntity.id, legalEntity);
    } else {
      return this.apiService.post(this.path, legalEntity);
    }
  }

  public get(id: number): Observable<LegalEntity> {
    return this.apiService.getSave(this.path + '/' + id);
  }
}
